import "./unlockscreen.css";
import { useEffect } from "react";

const Unlockscreen = ({ setTimeUnlockCurrent }) => {
  let svg;
  let dots;
  let wholeContainer;
  let wrapper;
  let currentPatternTextBox;
  let timeOut;

  const reset = () => {
    hoveredDots = [];
    dots.forEach((dot) => (dot.style.backgroundColor = "#fff"));
    const lines = document.querySelectorAll("line");
    lines.forEach((line) => line.remove());
    currentPatternTextBox.value = "";
  };

  let line,
    isClicked = false,
    startX,
    startY;
    
  let hoveredDots = [];

  let calculatedDotsCenters = [];

  const calculateDotsCenter = () => {
    let wrapperRect = wrapper.getBoundingClientRect();

    for (let i = 0; i < dots.length; i++) {
      let dot = dots[i];
      let dotRect = dot.getBoundingClientRect();

      let dotCoordinates = {
        x: Math.ceil(dotRect.left + dotRect.width / 2 - wrapperRect.left),
        y: Math.ceil(dotRect.bottom - dotRect.height / 2 - wrapperRect.top),
        num: i + 1,
      };

      calculatedDotsCenters.push(dotCoordinates);
    }
  };

  let winningPatern = [1, 2, 3, 6, 9, 8];

  /*const correctPattern = () => {
    let pattern = document.querySelector(".correctPattern");
    pattern.value = `Unlock pattern is: ${winningPatern.toString()}`;
  };
*/
  const checkIfHovered = (index) => {
    return hoveredDots.includes(index);
  };

  const bodyHover = (ev) => {
    if (isClicked) drawingLine(ev, false);
  };

  const bodyHoverTouch = (ev) => {
    if (isClicked) drawingLine(ev, true);
  };

  const makeColor = (isCorrect) => {
    const lines = document.querySelectorAll("line");
    lines.forEach((line) =>
      line.setAttribute("stroke", isCorrect ? "green" : "red")
    );
    hoveredDots.forEach(
      (index) =>
        (dots[index].style.backgroundColor = isCorrect ? "green" : "red")
    );
  };

  const checkPattern = () => {
    let isCorrect = true;
    hoveredDots.forEach((item, index) => {
      if (hoveredDots.length !== winningPatern.length) {
        isCorrect = false;
        return;
      }
      if (calculatedDotsCenters[item].num !== winningPatern[index]) {
        isCorrect = false;
        return;
      }
    });
    makeColor(isCorrect);

    if (isCorrect && hoveredDots.length > 0) {
      hoveredDots = [];
      setTimeUnlockCurrent(true);
      return;
    }
    let unlockscreen = document.querySelector(".unlock-screen");

    wrapper.removeEventListener("mousemove", bodyHover);

    timeOut = setTimeout(() => {
      reset();
      if (unlockscreen === null) return;
    }, 1000);
    isClicked = false;
    if (unlockscreen === null) return;
  };

  const checkPatternTouch = () => {
    let isCorrect = true;
    hoveredDots.forEach((item, index) => {
      if (hoveredDots.length !== winningPatern.length) {
        isCorrect = false;
        return;
      }
      if (calculatedDotsCenters[item].num !== winningPatern[index]) {
        isCorrect = false;
        return;
      }
    });
    makeColor(isCorrect);
    if (isCorrect === true && hoveredDots.length > 0) {
      hoveredDots = [];
      setTimeUnlockCurrent(true);
      return;
    }
    let unlockscreen = document.querySelector(".unlock-screen");

    wrapper.removeEventListener("touchmove", bodyHoverTouch);
    timeOut = setTimeout(() => {
      reset();
      if (unlockscreen === null) {
        return;
      }
      unlockscreen.style.pointerEvents = "auto";
    }, 1000);
    isClicked = false;
    if (unlockscreen === null) return;
    unlockscreen.style.pointerEvents = "none";
  };

  function checkTouch(dot, ev) {
    const dimension = dot.getBoundingClientRect();
    const cordinate = ev.touches[0];
    if (
      cordinate.clientX > dimension.left &&
      cordinate.clientX < dimension.right &&
      cordinate.clientY > dimension.top &&
      cordinate.clientY < dimension.bottom
    )
      return true;
    return false;
  }

  function checkMouse(dot, ev) {
    const dimension = dot.getBoundingClientRect();

    if (
      ev.clientX > dimension.left &&
      ev.clientX < dimension.right &&
      ev.clientY > dimension.top &&
      ev.clientY < dimension.bottom
    )
      return true;
    return false;
  }

  const drawingLine = (ev, touch) => {
    if (touch) {
      line.setAttribute(
        "x2",
        Math.ceil(ev.touches[0].clientX) -
          window.innerWidth / 2 +
          wholeContainer.getBoundingClientRect().width / 2
      );

      line.setAttribute(
        "y2",
        Math.ceil(ev.touches[0].clientY) -
          window.innerHeight / 2 +
          wholeContainer.getBoundingClientRect().height / 2
      );
      svg.appendChild(line);
      dots.forEach((dot, index) => {
        if (checkTouch(dot, ev) && !checkIfHovered(index)) {
          line.setAttribute("x2", calculatedDotsCenters[index].x);
          line.setAttribute("y2", calculatedDotsCenters[index].y);
          dot.style.backgroundColor = "blue";
          line = document.createElementNS("http://www.w3.org/2000/svg", "line");
          line.setAttribute("stroke", "blue");
          line.setAttribute("stroke-width", "4");
          startX = calculatedDotsCenters[index].x;
          startY = calculatedDotsCenters[index].y;
          line.setAttribute("x1", startX);
          line.setAttribute("y1", startY);
          hoveredDots.push(index);
          currentPatternTextBox.value =
            currentPatternTextBox.value + (index + 1);
          if (hoveredDots.length === dots.length) {
            isClicked = false;

            wrapper.removeEventListener("touchmove", bodyHoverTouch);

            checkPatternTouch();
            return;
          }
        }
      });
    } else {
      line.setAttribute(
        "x2",
        ev.clientX -
          window.innerWidth / 2 +
          wholeContainer.getBoundingClientRect().width / 2
      );
      line.setAttribute(
        "y2",
        ev.clientY -
          window.innerHeight / 2 +
          wholeContainer.getBoundingClientRect().height / 2
      );
      svg.appendChild(line);
      dots.forEach((dot, index) => {
        if (checkMouse(dot, ev) && !checkIfHovered(index)) {
          line.setAttribute("x2", calculatedDotsCenters[index].x);
          line.setAttribute("y2", calculatedDotsCenters[index].y);
          dot.style.backgroundColor = "blue";
          line = document.createElementNS("http://www.w3.org/2000/svg", "line");
          line.setAttribute("stroke", "blue");
          line.setAttribute("stroke-width", "4");

          startX = calculatedDotsCenters[index].x;
          startY = calculatedDotsCenters[index].y;

          line.setAttribute("x1", startX);
          line.setAttribute("y1", startY);
          hoveredDots.push(index);
          currentPatternTextBox.value =
            currentPatternTextBox.value + (index + 1);
          if (hoveredDots.length === dots.length) {
            isClicked = false;

            wrapper.removeEventListener("mousemove", bodyHover);

            checkPattern();
            return;
          }
        }
      });
    }
  };

  useEffect(() => {
    svg = document.querySelector(".unlock-svg");
    dots = document.querySelectorAll(".dot");
    wholeContainer = document.querySelector(".wholeContainer");
    wrapper = document.querySelector(".wrapper");
    currentPatternTextBox = document.querySelector(".currentPattern");

    calculateDotsCenter();
    //correctPattern();

    dots.forEach((dot, index) => {
      dot.addEventListener("mousedown", (e) => {
        if (isClicked) {
          wrapper.removeEventListener("mousemove", bodyHover);
          checkPattern();
          isClicked = !isClicked;
          return;
        } else {
          wrapper.addEventListener("mousemove", bodyHover);
          wrapper.addEventListener("mouseup", checkPattern);
          line = document.createElementNS("http://www.w3.org/2000/svg", "line");
          line.setAttribute("stroke", "blue");
          line.setAttribute("stroke-width", "4");
          isClicked = !isClicked;
          startX = calculatedDotsCenters[index].x;
          startY = calculatedDotsCenters[index].y;
          line.setAttribute("x1", startX);
          line.setAttribute("y1", startY);
          hoveredDots.push(index);
          currentPatternTextBox.value = index + 1;
          dot.style.backgroundColor = "blue";
        }
      });
    });

    dots.forEach((dot, index) => {
      dot.addEventListener("touchstart", (e) => {
        if (isClicked) {
          wrapper.removeEventListener("touchmove", bodyHoverTouch);
          checkPatternTouch();

          return;
        } else {
          wrapper.addEventListener("touchmove", bodyHoverTouch);
          wrapper.addEventListener("touchend", checkPatternTouch);
          line = document.createElementNS("http://www.w3.org/2000/svg", "line");
          line.setAttribute("stroke", "blue");
          line.setAttribute("stroke-width", "4");
          isClicked = !isClicked;
          startX = calculatedDotsCenters[index].x;
          startY = calculatedDotsCenters[index].y;

          line.setAttribute("x1", startX);
          line.setAttribute("y1", startY);
          hoveredDots.push(index);
          currentPatternTextBox.value = index + 1;
          dot.style.backgroundColor = "blue";
        }
      });
    });

    document.addEventListener("mouseup", checkPattern);
  }, []);

  return (
    <div className="unlock-screen">
      <div className="wrapper">
        <div className="wholeContainer">
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
          <div className="dot-container">
            <div className="dot"></div>
          </div>
        </div>
        <svg className="unlock-svg" height="300" width="300"></svg>

        <input type="text" name="currentPattern" className="currentPattern" />
      </div>
    </div>
  );
};

export default Unlockscreen;
